import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onbudsman',
  templateUrl: './onbudsman.component.html',
  styleUrls: ['./onbudsman.component.scss']
})
export class OnbudsmanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
